import React, { Component } from "react";
import { ModuleAccordionGroup } from '@loanbossinc/component-library';
import { get } from 'lodash';
import { rows as personalGuarantorsRows } from './section-loan-personal-guarantor-rows';
import { rows as companyGuarantorsRows } from './section-loan-company-guarantor-rows';
import { AccordionSection } from "component-lib/AccordionSection";
import { LOAN_SECTION_KEYS } from '../loan.constants';
import { findSummaryText } from '../loanDetailEditUtil';
const SHORTHAND_FIELD = "LoanGuarantor";
// SEE COMMENT ABOVE EXTENSIONS! THIS WILL USE THE SAME PATTERN!

export class LoanGuarantor extends Component {
  state = {
    guarantorRecourseSchedulesIndex: null
  }
  
  expandRow = (item, index, type) =>{
    const { data } = this.props;
    if (!data) return null;
    const allGuarantors = [...data.companyGuarantors, ...data.personalGuarantors]
    allGuarantors.forEach(ag => ag.guarantorRecourseSchedules.forEach(x => {
      if(x.id !== item.id)
        x.isDetailsExpanded = false;
    }));

    const guarantors = get(data,type);
    const guarantor = guarantors[index];
    const guarantorRecourseSchedulesIndex = guarantor.guarantorRecourseSchedules.findIndex(x => x.id === item.id);
    item.isDetailsExpanded = !item.isDetailsExpanded;
    this.setState({ guarantorRecourseSchedulesIndex: guarantorRecourseSchedulesIndex });
  };

  mapNameFromContact = (contact) => {
    if (!contact) return '--';
    return `${contact.firstName} ${contact.lastName}`.trim();
  }
  
  mapCompanyGuarantors = () => {
    const { data } = this.props;
    if (!data) return [];
    
    const companyGuarantors = data.companyGuarantors || [];
    return companyGuarantors.map(item => ({
      ...item
      , title: item.companyName
      , subTitle: 'Company Guarantor'
    }))
  }
  
  companyGroups(history, loanId, enableEditButton,) {
    const { data, markAsComplete } = this.props;
    const companyGuarantors = this.mapCompanyGuarantors();
    return companyGuarantors.reduce((accum, guarantor, index) => {
      if (!guarantor)
      return accum;
      accum.push({
        title: guarantor.title,
        subTitle: guarantor.subTitle,
        key: `section-company-guarantor-${index}`,
        isTitleGroup: false,
        isExpandable: true,
        buttonLabel: 'Edit Details',
        showEditButton: enableEditButton,
        onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.COMPANY_GUARANTORS}/${guarantor.id}`),
        sections: [<AccordionSection eventHandlers={this.props.eventHandlers} rows={companyGuarantorsRows(this.expandRow, data, index, this.state.guarantorRecourseSchedulesIndex, markAsComplete)} data={guarantor} />]
      });
      return accum;
    }, []);
  }
  
    mapPersonalGuarantors = () => {
      const { data } = this.props;
      if (!data) return [];
  
      const personalGuarantors = data.personalGuarantors || [];
      return personalGuarantors.map(item => ({
        ...item
        , title: this.mapNameFromContact(item.contact)
        , subTitle: 'Personal Guarantor'
      }))
    }
  
  personalGroups(history, loanId, enableEditButton,) {
    const { data, markAsComplete } = this.props;
    const personalGuarantors = this.mapPersonalGuarantors();
    return personalGuarantors.reduce((accum, guarantor, index) => {
      if (!guarantor)
      return accum;
      
      accum.push({
        title: guarantor.title,
        subTitle: guarantor.subTitle,
        sortOrder: index,
        key: `section-personal-guarantor-${index}`,
        isTitleGroup: false,
        isExpandable: true,
        buttonLabel: 'Edit Details',
        showEditButton: enableEditButton,
        onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.PERSONAL_GUARANTORS}/${guarantor.id}`),
        sections: [<AccordionSection eventHandlers={this.props.eventHandlers} rows={personalGuarantorsRows(this.expandRow, data, index, this.state.guarantorRecourseSchedulesIndex, markAsComplete)} data={guarantor} />]
      });
      return accum;
    }, []);
  }

  mapGuarantorGroups = () => {
    const { data, history, loanId, enableEditButton, modifySummaryText, eventHandlers } = this.props;
    const summaryText = findSummaryText(data,SHORTHAND_FIELD);

    const personalGuarantorGroups = this.personalGroups(history, loanId, enableEditButton);
    const companyGuarantorGroups = this.companyGroups(history, loanId, enableEditButton);
    
    let groups = [
      {
        title: 'Guarantors',
        key: LOAN_SECTION_KEYS.GUARANTOR,
        isTitleGroup: true,
        isExpandable: false, 
        hasSummaryText: true,
        summaryText: summaryText,
        modifySummaryText: () => modifySummaryText(SHORTHAND_FIELD, summaryText),
        references: data.references,
        referencedFieldPath: "loans.guarantors",
        isReferenceOptions: true,
        eventHandlers
      },{
        title: 'Personal Guarantors',
        key: LOAN_SECTION_KEYS.PERSONAL_GUARANTORS,
        isTitleGroup: false,
        isExpandable: false,
        style: { backgroundColor: "#fbfbfb"}
      }
    ]
    if(personalGuarantorGroups.length > 0) groups = groups.concat(personalGuarantorGroups);    
    groups.push(
      { 
        isButton: true,
        key: `guarantors-add-button`,
        buttonLabel: 'Add new personal guarantor',
        showEditButton: enableEditButton,
        onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.PERSONAL_GUARANTORS}/new/${data.personalGuarantors ? data.personalGuarantors.length : 0}`)
      });
    
    groups.push({
      title: 'Company Guarantors',
      key: LOAN_SECTION_KEYS.COMPANY_GUARANTORS,
      isTitleGroup: false,
      isExpandable: false,
      style: { backgroundColor: "#fbfbfb"}
    })
    if(companyGuarantorGroups.length > 0) groups = groups.concat(companyGuarantorGroups);
    groups.push(
      {
        isButton: true,
        key: `guarantors-add-button`,
        buttonLabel: 'Add new company guarantor',
        showEditButton: enableEditButton,
        onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.COMPANY_GUARANTORS}/new/${data.companyGuarantors ? data.companyGuarantors.length : 0}`)
      });
    return groups;
  }

  render() {
    const { data, ...other } = this.props;
    const groups = this.mapGuarantorGroups();

    return <ModuleAccordionGroup {...other} groups={groups} />;
  }
}
